import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'react-jss';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { ComponentSettings, ThemeFluent } from '@bingads-webui-theme-2018/theme-fluent';
import { Panel } from '@bingads-webui-campaign-react/panel';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { KeywordPlanner } from './keyword-planner';
import { getPanelStyles } from './style/panel-style';
import { PanelHeader } from './panel-header';

export const KeywordPlannerPanel = ({
  isOpen,
  onClose,
  i18n,
  targetedLocationInfo,
  supportedLanguages,
}) => {
  const classes = useDefaultStyles(getPanelStyles);
  const onCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Panel
      isOpen={isOpen}
      onClose={onCancel}
      i18n={i18n}
      panelClassName="side-panel-keyword-planner"
      title={<PanelHeader i18n={i18n} />}
      className={classes}
    >
      <ThemeProvider theme={{ components: ComponentSettings, core: ThemeFluent }} >
        <FluentProvider theme={webLightTheme} className={classes.flexContainer} >
          <KeywordPlanner
            onClose={onClose}
            targetedLocationInfo={targetedLocationInfo}
            supportedLanguages={supportedLanguages}
          />
        </FluentProvider>
      </ThemeProvider>
    </Panel>
  );
};

KeywordPlannerPanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  targetedLocationInfo: PropTypes.shape({}).isRequired,
  supportedLanguages: PropTypes.arrayOf(PropTypes.string).isRequired,
};
